"use client";

import { useEffect } from "react";
import { useLocale } from "next-intl";
import type { AvailableLocales } from "@onclicks/sharedmobilei18n/routing";
import { setApiErrorLocale } from "../utils/translate-api-error";

export function ApiErrorLocaleSync() {
  const locale = useLocale() as AvailableLocales;

  useEffect(() => {
    setApiErrorLocale(locale);
  }, [locale]);

  return null;
}
